import { BarChart3, Brain, Cog, Target } from "lucide-react";
import { Btn, Eyebrow, PageHero } from "@/components/site/bits";
import { Reveal } from "@/components/site/Reveal";
import { BOOK_URL, IMAGES } from "@/data/site";

const resources = [
    {
        icon: Brain,
        title: "The Anatomy of Addiction",
        text: "Understand how addiction develops and the factors that can contribute to the cycle — brain, body, and behavior.",
    },
    {
        icon: Target,
        title: "The Anatomy of Relapse",
        text: "Recognize triggers, warning signs, and behaviors that may lead to relapse, and how to prepare for them.",
    },
    {
        icon: Cog,
        title: "The Subconscious Mind",
        text: "Explore how thoughts, habits, past experiences, and impulsive responses influence behavior.",
    },
    {
        icon: BarChart3,
        title: "Recovery & Support Tools",
        text: "Learn practical tools and strategies for long-term change and personal growth.",
    },
];

export default function Resources() {
    return (
        <main>
            <PageHero
                testid="resources-hero"
                eyebrow="Resources"
                title="Knowledge Creates Change"
                sub="Education is a powerful tool. Understanding the patterns behind addiction can help you make different choices and build a healthier future."
                image={IMAGES.framework}
            />
            <section className="bg-[#F9F8F3]">
                <div className="mx-auto max-w-7xl px-6 py-20 sm:py-24">
                    <div className="grid gap-8 sm:grid-cols-2">
                        {resources.map(({ icon: Icon, title, text }, i) => (
                            <Reveal key={title} delay={i * 0.06}>
                                <div data-testid={`resource-card-${i}`} className="flex h-full gap-5 rounded-xl border border-[#0B1F3A]/10 bg-white p-8 transition-transform duration-300 hover:-translate-y-1.5">
                                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#0B1F3A] text-[#D4AF37]">
                                        <Icon className="h-5 w-5" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-bold text-[#0B1F3A]">{title}</h3>
                                        <p className="mt-2 text-sm leading-relaxed text-[#4A5568]">{text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.1} className="mt-16">
                        <div className="flex flex-col items-center justify-between gap-6 rounded-2xl bg-[#0B1F3A] p-10 sm:flex-row">
                            <div>
                                <Eyebrow light>Go Deeper</Eyebrow>
                                <h2 className="mt-2 text-xl sm:text-2xl font-extrabold text-white">
                                    Breaking the Chains: A Neuro-Bio-Spiritual Path to Freedom
                                </h2>
                                <p className="mt-2 max-w-xl text-sm text-white/75">
                                    The complete framework — in Dr. Jaquez’s book.
                                </p>
                            </div>
                            <Btn testid="resources-buy-book-btn" href={BOOK_URL} cart>Purchase the Book</Btn>
                        </div>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
